import React from 'react'

function VideoFlipped ({titulo, onClick}) {
    return (
        <div className="videoFlipped">
            <div 
                className="botonVideoFlipped" 
                onClick={ onClick }
            />{' '}
            <div
                className="textoVideoFlipped"
                dangerouslySetInnerHTML={{ __html: titulo }}
            />
        </div>
    )
}

function LeccionFlipped ({ numUnidad, titulo, video, lesson, ficha, onEntrada }) {
    return (
        <div className={`leccion${numUnidad}`}>
            <div className="encabezadoFlipped">
                <div className="bullet"></div>
                <span dangerouslySetInnerHTML={{__html: titulo}} />
                { lesson }
            </div>
            <div className="contenedorVideosFlipped">
                { video.map( ({titulo, ...accion}) => 
                    <VideoFlipped titulo={ titulo } onClick={ () => onEntrada(accion) } />                    
                )}                
            </div>
            <div className="fichaFlipped" onClick={ () => onEntrada( ficha )}>
                <span dangerouslySetInnerHTML={{__html: ficha.titulo }} />
            </div>
        </div>
    )
}

export default LeccionFlipped